import React from 'react';
import PropTypes from 'prop-types';
import { BRANCHING_FIELD_TYPES } from 'utils/conditionalConstants';
import { FIELD_NAMES } from 'utils/constants';
import LogicEditor from './LogicEditor';
import BranchAssignments from './BranchAssignments';

const ConditionalEditor = (props) => {
  const canRenderConditionalEditor = (!Object.keys(props.branchingQuestion).length || props.isBranchingField) &&
    BRANCHING_FIELD_TYPES.includes(props.values.type);

  const canRenderBranchAssigner = (
    props.branchingQuestion.step && props.step > props.branchingQuestion.step) &&
    Object.keys(props.fieldConditionalityInfo.branchingFields).length &&
    props.values.name !== FIELD_NAMES.PHONE;

  if (canRenderConditionalEditor) {
    return (
      <LogicEditor
        activeBranches={props.activeBranches}
        fieldConditionalityInfo={props.fieldConditionalityInfo}
        isBranchingField={props.isBranchingField}
        keyPath={[...props.keyPath, 'fieldConditionalityInfo']}
        onFieldValueChange={props.onFieldValueChange}
        values={props.values}
        toggleBranching={props.toggleBranching}
      />

    );
  } if (canRenderBranchAssigner) {
    return (
      <BranchAssignments
        activeBranches={props.activeBranches}
        branchMembership={props.branchMembership}
        branchingQuestion={props.branchingQuestion}
        fieldConditionalityInfo={props.fieldConditionalityInfo}
        fieldId={props.values.id}
        toggleBranchMembership={props.toggleBranchMembership}
      />
    );
  }
  return null;
};

ConditionalEditor.propTypes = {
  activeBranches: PropTypes.object.isRequired,
  fieldConditionalityInfo: PropTypes.object.isRequired,
  isBranchingField: PropTypes.bool.isRequired,
  keyPath: PropTypes.array.isRequired,
  onFieldValueChange: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  toggleBranching: PropTypes.func.isRequired,
  branchMembership: PropTypes.array.isRequired,
  branchingQuestion: PropTypes.object.isRequired,
  toggleBranchMembership: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,

};

export default ConditionalEditor;
